import React from "react";
import { Colors } from "../../assets/Colors";
import "./courseSlider.css"

function CourseSlideCard({name,img,url}) {
  return (
    <a
      className="CourseSliderCard"
      href={url}
      target="_blank"
      style={{backgroundColor:'rgb(250,250,250)'}}
    >
      <img src={img} className="CourseSliderImage"></img>
      {/* <span>{name}</span> */}
    </a>
  );
}

export default CourseSlideCard;
